<template>
    <div :class="{
        'row question justify-content-center': true,
        'question-error': error
    }">
        <div class="col-sm-10 col-sm-offset-1">
            <h5>Question {{ id }}.</h5>
            <label>{{ data }}</label>
        </div>
        <div class="col-sm-5 col-sm-offset-1">
            <div class="btn-group push-15 btn-group-justified">
                <div class="btn-group">
                    <button
                        type="button"
                        :class="{
                            'btn': true,
                            'btn-sm b-r-0': btnIsSmall,
                            'mr-2' : !btnIsSmall,
                            'btn-selected btn-fill': choice == '1'
                        }"
                        @click="$emit('change', '1')">
                        Yes
                    </button>
                </div>
                <div class="btn-group">
                    <button
                        type="button"
                        :class="{
                            'btn': true,
                            'btn-sm' : btnIsSmall,
                            'btn-selected btn-fill': choice == '0'
                        }"
                        @click="$emit('change', '0')">
                        No
                    </button>
                </div>
            </div>
        </div>
        <div v-if="error" class="col-sm-10 col-sm-offset-1 question-error-message">
            We will need to review this before cover can be confirmed.
        </div>
    </div>
</template>

<script>
    import VueScrollTo from 'vue-scrollto'

    export default {
        props: {
            id: {
				type: Number,
				required: true
            },
            data: {
                type: String,
                required: true
            },
            choice: {
                type: String
            },
            error: {
                type: Boolean
            },
            btnIsSmall: {
                type: Boolean,
                default: true
            },
        },

        mounted(){
        },
        methods: {
            scrollTo () {
                VueScrollTo.scrollTo(this.$el, 500, {
                    offset: -200,
                })
            }
        }
    }
</script>

<style lang="scss">
@import '../../sass/form/global';

.question {
    padding-bottom: 6px;
}

.question-error {
    background-color: #ffdbdb;
}

.question-error-message {
    color: #ff0000;
}
</style>
